import { BREAKPOINT_MOBILE } from "../../../constants";

export const ETALON_MQ = 4000;
export const STEP = 100;
export const BR_POINT_MOBILE = BREAKPOINT_MOBILE;
export const DEBOUNCE = 80;